import { useNavigate } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';
import { Lock } from 'lucide-react';
import Panel from '@/components/Panel';

export default function Unauthorized() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--app-bg)] p-4">
      <Panel className="max-w-md p-8 text-center">
        <Lock size={40} className="mx-auto mb-3 text-warning-500" />
        <h1 className="text-xl font-bold text-[var(--app-text)]">Not your permission</h1>
        <p className="mt-1 text-sm text-[var(--app-muted)]">
          Your account doesn't have access to that page. Ask an administrator if you need it.
        </p>
        <Button className="mt-5" onClick={() => nav('/')}>
          Back to the dashboard
        </Button>
      </Panel>
    </div>
  );
}
